import "./Admin.scss";

export default {
  name: "Admin",

  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  }
};
